import {Text} from 'platform/foundation';

import {CellRendererProps} from '../../types/CellRendererProps';
import {getDisplayValue} from '../../utils/getDisplayValue';

type FileEntry = {
  title?: string;
};

type FilePlainCellRendererProps = CellRendererProps<unknown>;

export function FilePlainCellRenderer(props: FilePlainCellRendererProps) {
  const values = props.value as FileEntry | undefined;
  return <Text size="small">{getDisplayValue(values?.title, props.emptyCellValue)}</Text>;
}
